import Main from './views/Main.vue';
import Page from './views/Page.vue';
import Auth from './views/Auth.vue';
import Notfound from './views/Notfound.vue';
import Position from './views/Position.vue';
import Users from './views/Users.vue';
import UserAdd from './views/UserAdd.vue';
import UserEdit from './views/UserEdit.vue';
import User from './views/User.vue';
import Help from './views/Help.vue';
import HelpItem from './views/HelpItem.vue';
import Faq from './views/Faq.vue';
import Order from './views/Order.vue';
import OrderAdd from './views/OrderAdd.vue';

import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import store from './store'

// Охранник для неавторизованных пользователей
// Разрешает доступ только если пользователь не авторизован
const ifNotAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== true) {
        next()
        return
    }
    // Если пользователь авторизован, перенаправляем на главную
    next('/')
}

// Охранник для авторизованных пользователей
// Разрешает доступ только если пользователь авторизован
const ifAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== false) {
        next()
        return
    }
    // Если пользователь не авторизован, перенаправляем на страницу авторизации
    next('/auth/')
}

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) {
            return false // отключаем скролл
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    routes: [
        {
            path: '/auth/',
            component: Auth,
            name: 'auth',
            meta: {
                layout: 'empty',
                name: 'Авторизация',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/page/:id/',
            component: Page,
            name:'page',
            meta: {layout: 'main', name: '', show_prev: true,
                requiresAuth: true},
        },
        {
            path: '/position/',
            component: Position,
            name: 'position',
            meta: { layout: 'main', name: 'Заказы (развернуто)', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/users/',
            component: Users,
            name: 'users',
            meta: { layout: 'main', name: 'Пользователи', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/user/add/',
            component: UserAdd,
            name: 'user-add',
            meta: { layout: 'main', name: 'Добавить пользователя', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/user/edit/:id/',
            component: UserEdit,
            name: 'user-edit',
            meta: { layout: 'main', name: 'Изменить пользователя', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/user/:id/',
            component: User,
            name: 'user',
            meta: { layout: 'main', name: 'Пользователь', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/help/',
            component: Help,
            name: 'help',
            meta: { layout: 'main', name: 'Помощь', show_prev: true, narrow_page: true,
                requiresAuth: true }
        },
        {
            path: '/help/faq/',
            component: Faq,
            name: 'faq',
            meta: { layout: 'main', name: 'Faq', show_prev: true, narrow_page: true,
                requiresAuth: true  }
        },
        {
            path: '/help/:id/',
            component: HelpItem,
            name: 'help-item',
            meta: { layout: 'main', name: 'Раздел помощи', show_prev: true, narrow_page: true,
                requiresAuth: true  }
        },
        {
            path: '/order/add/',
            component: OrderAdd,
            name: 'order-add',
            meta: { layout: 'main', name: 'Добавление заказа', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/order/:id/',
            component: Order,
            name: 'order',
            meta: { layout: 'main', name: 'Заказ', show_prev: true,
                requiresAuth: true }
        },
        {
            path: '/',
            component: Main,
            name: 'main',
            meta: {layout: 'main', name: 'Заказы', main_page: true,
                requiresAuth: true},
            beforeEnter: ifAuthenticated
        },
        {
            path: '/:pathMatch(.*)*',
            component: Notfound,
            name: 'notfound',
            meta: {layout: 'main', name: 'Страница 404', show_prev: true}
        },
    ]
})

const defaultDocumentTitle = typeof document !== 'undefined' ? document.title : ''

router.afterEach((to) => {
    if (typeof document === 'undefined') {
        return
    }

    const routeTitle = typeof to.meta.name === 'string' ? to.meta.name.trim() : ''
    document.title = routeTitle || defaultDocumentTitle
})

export default router
